/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbqin
 * @LastEditTime: 2022-03-10 15:34:19
 * @Description: file content
 */
import React, { Component } from 'react';
import { getSysFieldid } from '@platform/api';

require('./index.less');

export default class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {}
        };
    }
    render() {
        let { showStar, fieldid, value, className = '', onChange, onBlur, ...others } = this.props;
        if (!value || typeof value !== 'string') {
            value = '';
        }
        value = value && value.replace(/./g, '*');
        // return <FormControl {...this.props} />;
        return (
            <div className={`base-input-wrapper ${className}`} >
                {showStar ? <span className="input-required-tag">*</span> : ''}
                <input
                    fieldid={getSysFieldid(fieldid) || null}
                    className="base-input"
                    value={value}
                    onChange={e => {
                        onChange(e.target.value);
                    }}
                    onBlur={e => onBlur(e.target.value)}
                    {...others}
                />
            </div>
        );
    }
}
